import { API_ENDPOINTS } from '../config/api';
import { requestNotificationPermission } from '../utils/notification';

const DEFAULT_BEARER_TOKEN = '';
const DEFAULT_DEVICE_NAME = 'LAIDO';

// Hàm xử lý chung cho response
const handleApiResponse = async (response) => {
  const data = await response.json();
  
  // Kiểm tra error_code = 1000
  if (data.error_code === 1000) {
    // Xóa session
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    // Chuyển về trang login
    window.location.href = '/';
    throw new Error('Phiên đăng nhập hết hạn');
  }

  if (!response.ok) {
    throw new Error(data.message || 'Có lỗi xảy ra');
  }

  return data;
};

// Login không sử dụng handleApiResponse
async function login(username, password) {
  try {
    const response = await fetch(API_ENDPOINTS.LOGIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();
    if (data.success && data.data.access_token) {
      // Sau khi đăng nhập thành công, xin quyền và lưu token notification
      try {
        const notificationResult = await requestNotificationPermission(true);
        if (!notificationResult.success) {
          console.warn('Không thể đăng ký nhận thông báo:', notificationResult.message);
        }
      } catch (error) {
        console.error('Lỗi khi đăng ký notification:', error);
      }
    }
    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw new Error('Đăng nhập thất bại');
  }
}

// Sử dụng handleApiResponse cho staffInfo
async function staffInfo() {
  try {
  const token = localStorage.getItem('token');
  
  const response = await fetch(API_ENDPOINTS.STAFF_INFO, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      },
    });

    return handleApiResponse(response);
  } catch (error) {
    console.error('Staff info error:', error);
    throw new Error('Lấy thông tin nhân viên thất bại');
  }
}

async function checkTicket(ticketCode) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.USE_TICKET + "?code=" + ticketCode, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      }
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Sử dụng vé thất bại');
    }
    return data;
  } catch (error) {
    console.error('Use ticket error:', error);
    throw error;
  }
}

async function checkTicketThinkSoft(ticketCode) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.USE_TICKET_THINKSOFT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      },
      body: JSON.stringify({
        ticket_code: ticketCode,
        secret_key: 'SHyMhZNVwFZUiSZVgBMdFvLGsivDOIkq',
        device_id: '16',
        ip: '1.1.1.1'
      })
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Sử dụng vé thất bại');
    }
    return data;
  } catch (error) {
    console.error('Use ticket ThinkSoft error:', error);
    throw error;
  }
}

async function getCheckedTickets(fromDate, toDate) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.GET_CHECKED_TICKETS + "?fromDate=" + fromDate + "&toDate=" + toDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      }
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Lấy thông tin thất bại');
    }
    return data.data;
  } catch (error) {
    throw error;
  }
}

async function getDashboardInfo(fromDate, toDate) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.GET_DASHBOARD_INFO + "?fromDate=" + fromDate + "&toDate=" + toDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      }
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Lấy thông tin thất bại');
    }
    return data.data;
  } catch (error) {
    throw error;
  }
}

async function getShiftReport(fromDate, toDate) {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.GET_SHIFT_REPORT + "?from_date=" + fromDate + "&to_date=" + toDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      }
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Lấy thông tin thất bại');
    }
    return data.data;
  } catch (error) {
    throw error;
  }
}

// Login không sử dụng handleApiResponse
async function changePassword(oldPassword, newPassword, confirmPassword) {
  try {
    oldPassword = btoa(oldPassword);
    newPassword = btoa(newPassword);
    confirmPassword = btoa(confirmPassword);
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.CHANGE_PASSWORD + "?old_password=" + oldPassword + "&new_password=" + newPassword + "&confirm_password=" + confirmPassword, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      },
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Đổi mật khẩu thất bại');
    }
    return data;
  } catch (error) {
    console.error('Change password error:', error);
    return { success: false, message: 'Đổi mật khẩu thất bại' };
  }
}

async function submitReview(reviewData) {
  try {
    const response = await fetch(API_ENDPOINTS.SAVE_REVIEW, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reviewData),
    });

    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Review thất bại');
    }
    return data;
  } catch (error) {
    console.error('Review error:', error);
    return { success: false, message: 'Review thất bại' };
  }
}

async function getStaffShifts() {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.STAFF_SHIFT, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      }
    });
    
    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Lấy thông tin thất bại');
    }
    return data.data;
  } catch (error) {
    console.error('Get staff shifts error:', error);
    throw error;
  }
}

async function selectMeal(staffShiftId,productIds) {
  try {
    const token = localStorage.getItem('token');
    const params = {
      staff_shift_id: staffShiftId,
      product_ids: productIds.join(',')
    }
    const response = await fetch(API_ENDPOINTS.SELECT_MEAL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || DEFAULT_BEARER_TOKEN}`,
      },
      body: JSON.stringify(params)
    });
    
    const data = await response.json();
    if (typeof data.success == 'undefined') {
      throw new Error(data.message || 'Chọn món thất bại');
    }
    return data;
  } catch (error) {
    console.error('Select meal error:', error);
    throw error;
  }
}


// Thêm hàm logout
function logout() {
  
  localStorage.removeItem('user');
  // Xóa token xác thực (nếu có)
  localStorage.removeItem('token');
  window.location.href = '/';
}

export { 
  login, 
  staffInfo, 
  checkTicket,
  checkTicketThinkSoft,
  getCheckedTickets, 
  getDashboardInfo, 
  getShiftReport, 
  changePassword,
  submitReview,
  getStaffShifts,
  selectMeal,
  logout
};
